import React, { useEffect, useRef, useState } from "react";
import { Modal } from "../../library/components/Modal";
import { ButtonMd } from "../../library/symbols/buttons";
import "/website/assets/scss/pages/itinerary_detail_public/_share-media-modal.scss";
import "/website/assets/scss/symbols/_icons.scss";
export function ShareMediaModal({ isOpen, onClose, itinerary }) {
    const urlSpan = useRef(null);
    const [fullUrl, setFullUrl] = useState();
    useEffect(() => {
        if (itinerary) {
            const baseUrl = `${window.location.protocol}//${window.location.host}`;
            setFullUrl(`${baseUrl}${itinerary.url}`);
        }
    }, [itinerary]);
    function copyToClipboard(text) {
        navigator.clipboard
            .writeText(text)
            .finally();
        const selection = window.getSelection();
        const range = new Range();
        range.selectNodeContents(urlSpan.current);
        selection.removeAllRanges();
        selection.addRange(range);
    }
    return (React.createElement(Modal, { isOpen: isOpen, onClose: onClose },
        React.createElement("div", { className: "share-media-modal" },
            React.createElement("h1", { className: "share-media-modal__title" }, "Compartir itinerario"),
            React.createElement("div", { className: "share-media-modal__link share-media-section" },
                React.createElement("h2", { className: "share-media-section__title" }, "Enlace del itinerario"),
                React.createElement("div", { className: "share-media-section__copy-input" },
                    React.createElement("div", { className: "copy-link" },
                        React.createElement("span", { ref: urlSpan, className: "copy-link__link" }, fullUrl),
                        React.createElement(ButtonMd, { className: "copy-link__button", onClick: () => copyToClipboard(fullUrl) }, "Copiar")))),
            React.createElement("div", { className: "share-media-modal__social-media share-media-section" },
                React.createElement("h2", { className: "share-media-section__title" }, "Compartir directamente por"),
                React.createElement("div", { className: "share-media-section__buttons" },
                    React.createElement("a", { className: "btn-social", href: `https://wa.me/?text=Aprendé ${itinerary.title} en ${fullUrl}` },
                        React.createElement("i", { className: "icon icon-whatsapp btn-social__icon", "aria-hidden": "true" }),
                        React.createElement("span", { className: "btn-social__text" }, "WhatsApp")),
                    React.createElement("a", { className: "btn-social", href: `https://twitter.com/intent/tweet?text=Aprendé ${itinerary.title} en ${fullUrl}` },
                        React.createElement("i", { className: "icon icon-twitter btn-social__icon", "aria-hidden": "true" }),
                        React.createElement("span", { className: "btn-social__text" }, "Twitter")),
                    React.createElement("a", { className: "btn-social", href: `mailto:?to=&subject=Itinerario ${itinerary.title} en Club ArgenTec&body=Aprendé ${itinerary.title} en ${fullUrl}` },
                        React.createElement("i", { className: "icon icon-email btn-social__icon", "aria-hidden": "true" }),
                        React.createElement("span", { className: "btn-social__text" }, "Email")))))));
}
